import { pathOr } from "ramda";

interface Campaign {
  configuration: {
    productOnly?: boolean;
    customDomain?: string;
  };
  university?: {
    configuration: {
      custom_domain?: string;
    };
  } | null;
}

export const getDomain = (
  campaign?: Campaign,
  defaultDomain = "https://quiz.mystudy.fit",
) => {
  if (!campaign || !campaign.configuration.productOnly) {
    return defaultDomain;
  }

  const campaignDomain = pathOr(null, ["configuration", "customDomain"]);
  const universityDomain = pathOr(null, [
    "university",
    "configuration",
    "custom_domain",
  ]);

  return (
    campaignDomain(campaign) || universityDomain(campaign) || defaultDomain
  );
};
